module.exports = __webpack_public_path__ + "static/media/allinone_4.cde8edf0.svg";